import { defineMessages } from "react-intl";

export const giftCardBulkCreateDialogMessages = defineMessages({
  title: {
    id: "7dhhzL",
    defaultMessage: "Bulk Issue Gift Cards",
    description: "bulk issue gift cards dialog title",
  },
  createdSuccessAlertTitle: {
    id: "3bQz2o",
    defaultMessage: "Gift Cards Issued",
    description: "bulk issue gift cards success alert title",
  },
  createdSuccessAlertDescription: {
    id: "mbj1J5",
    defaultMessage: "Requested {cardsAmount} were successfully issued",
    description: "bulk issue gift cards success alert description",
  },
});
